import { render } from "./UserNoticeModal.vue?vue&type=template&id=54ac7ace&scoped=true"
import script from "./UserNoticeModal.vue?vue&type=script&lang=js"
export * from "./UserNoticeModal.vue?vue&type=script&lang=js"

import "./UserNoticeModal.vue?vue&type=style&index=0&id=54ac7ace&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ac7ace"]])

export default __exports__